<template>
  <div>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card md="1" bg-variant="none"> {{description}}</b-card>
      </b-col>
      <b-col md="1">
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card bg-variant="light">
          <p>Showcase images <b><u>relevant</u></b> to {{description}}
          <div v-if="showCollectionSelection">
            <collection-select @selectedItems="setCollectionId" />
          </div>
        <b-card>
        <b-form-file
          v-model="images"
          :state="Boolean(images)"
          placeholder="Choose an image or drop it here..."
          drop-placeholder="Drop image here..."
          multiple
        ></b-form-file>
        <div class="mt-3">Selected image: {{ images ? images.name : '' }}</div>
        <b-progress :value="in_progress" :max="max_progress" show-progress animated></b-progress>
        <b-button block variant="primary" @click="storeImages">Add Images to Collection</b-button>
      </b-card>
          </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {http_v1} from '@/axios'
import CollectionSelect from './CollectionSelect.vue'
import {amsMofifiedAttrs} from '@/utils'
import {deepEqual} from '@/utils'
import {amsSchema} from '@/schema'
import DataOperations from './DataOperations.vue'

export default {
  components: {
    CollectionSelect,
    DataOperations,
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    },
    filtering: {
      Type: Object
    },
  },
  data () {
    return {
      ams_type: 'collection-images',
      ams_api_path: 'api/admin/v1/',
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      api_route: 'api/admin/v1/collection_images', // refactor to use ams type/path
      images: [],
      in_progress: 0,
      max_progress: 100,
      progressInfos: [],
      message: "",
      fileInfos: [],
    }
  },
  computed: {
    showCollectionSelection() {
      return !(this.attr_copy['collection-id']?.length)
    },
    canUpdate() {
      return (
        this.attr_copy['product-listing-id']?.length > 0
        && this.attr_copy['collection-id']?.length > 0
        && (this.attr_copy['serial-number']?.length > 0 || this.attr_copy['serial-number'] > 0)
      )
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    },
    doDelete() {
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    setCollectionId(items) {
      this.attr_copy['collection-id'] = items[0].id
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, '_')
    },
    callApi () {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig)
      http_v1.post (
        this.apiResourcePath(), {
          ...attr_params
        }
      ).then(response => {
        if( response.data) {
         this.$store.dispatch('cached_products/add_product', response.data.data).then(() => {
          }).catch(() => {
          })
          this.$emit('takeAction')
          if(this.reroute) {
            this.$router.go(-1)
          }
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    callCancel() {
      this.$emit('noAction')
      if(this.reroute) {
        this.$router.go(-1)
      }
    },
    uploadApi(file, onUploadProgress) {
      let formData = new FormData()
      formData.append("image", file)
      formData.append("collection_id", this.attr_copy['collection-id'])
      if(this.attr_copy['product-item-id']) {
        formData.append("product_item_id", this.attr_copy['product-item-id'])
      }
      return http_v1.post(this.api_route, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        onUploadProgress
      }).then(response => {
        if( response.data) {
          this.$emit('takeAction')
          if(this.reroute) {
            // this.$router.go(-1)
            this.$router.push({ path: '/collection-images'})
          }
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    uploadImage(idx, file) {
      this.progressInfos[idx] = { percentage: 0, fileName: file.name }
      this.uploadApi(file, (event) => {
        this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total)
        this.in_progress = this.progressInfos[idx].percentage
      }).then((response) => {
        let prevMessage = this.message ? this.message + "\n" : ""
        this.message = prevMessage + response.data.message
      }).catch(() => {
        this.progressInfos[idx].percentage = 0
        this.message = "Could not upload the file:" + file.name
      })
    },
    storeImages () {
      this.message = ""
      for(let i = 0; i< this.images.length; i++ ) {
        this.uploadImage(i, this.images[i])
      }
      this.images = []
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted() {
    if(this.ams_template?.attributes) {
      this.attr_copy = {...this.ams_template.attributes}
    }
    else {
      const included_obj = amsSchema.find( 
        el =>  
        el.type === this.ams_type
      )
      this.attr_copy = {...included_obj.attributes}
    }
    this.description = this.ams_template?.description
  }
}
</script>

      
